import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useGetMockTestsQuery } from "@/features/api/mockTestApi";

const OnlinePayment = () => {
  const navigate = useNavigate();

  /* ================= FETCH MOCKS FROM BACKEND ================= */
  const {
    data,
    isLoading,
    isError,
    refetch,
  } = useGetMockTestsQuery();

  const mockTests = data?.mocks || [];

  /* ================= HANDLE BUY ================= */
  const handleBuyNow = (mock) => {
    if (!mock?._id) return;

    navigate(`/checkout?type=MOCK_TEST&id=${mock._id}`);
  };

  /* ================= LOADING ================= */
  if (isLoading) {
    return (
      <div className="max-w-6xl mx-auto px-4 py-12 text-center">
        <p className="text-lg font-medium">Loading mock tests...</p>
      </div>
    );
  }

  /* ================= ERROR ================= */
  if (isError) {
    return (
      <div className="max-w-6xl mx-auto px-4 py-12 text-center">
        <p className="text-red-600 mb-4">
          Failed to load mock tests.
        </p>
        <Button onClick={refetch}>
          Retry
        </Button>
      </div>
    );
  }

  /* ================= EMPTY STATE ================= */
  if (mockTests.length === 0) {
    return (
      <div className="max-w-6xl mx-auto px-4 py-12 text-center">
        <p className="text-gray-600">
          No mock tests available at the moment.
        </p>
      </div>
    );
  }

  /* ================= MAIN UI ================= */
  return (
    <div className="max-w-6xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-8 text-center">
        Mock Tests
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {mockTests.map((mock) => {
          const imageUrl =
            mock.image?.startsWith("/uploads")
              ? `https://fetc.in${mock.image}`
              : mock.image;

          return (
            <div
              key={mock._id}
              className="bg-white rounded-2xl shadow-md p-6 flex flex-col justify-between"
            >
              <div>
                {imageUrl && (
                  <img
                    src={imageUrl}
                    alt={mock.name}
                    className="w-full h-48 object-cover rounded-lg mb-4"
                    onError={(e) =>
                      (e.currentTarget.style.display = "none")
                    }
                  />
                )}

                <h2 className="text-xl font-semibold mb-2">
                  {mock.name}
                </h2>

                {mock.description && (
                  <p className="text-gray-600 text-sm mb-4">
                    {mock.description}
                  </p>
                )}

                <p className="text-lg font-bold text-blue-700">
                  ₹{Number(mock.price).toFixed(2)}
                </p>
              </div>

              <Button
                onClick={() => handleBuyNow(mock)}
                className="mt-4 w-full"
              >
                Pay Now
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OnlinePayment;